module.exports = __webpack_public_path__ + "static/step3-b75856c34c2f76681922bc5ce27c1f14.svg";